import { useCallback } from "react";
import { Magazine, pageFiles } from "./Datatypes";
import { fetchSinglePage } from "./FetchFromAPI";
import { usePersistBoundStore } from "./zustand/Store";

const alwaysRedownload = false;
const delay_time = 250;
const getAllStoredEpapers = usePersistBoundStore.getState().getAllStoredEpapers;
const updateStoredMagazine = usePersistBoundStore.getState().updateStoredMagazine;
const getStoredMagazineByMagazine = usePersistBoundStore.getState().getStoredMagazineByMagazine;
const updatePageFile = usePersistBoundStore.getState().updatePageFile;
const deleteAllStoredMagazines = usePersistBoundStore.getState().deleteAllStoredMagazines;

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
export async function prepareStoredMagazine(magazine: Magazine) {
    
    /*
    #
    #   Check if data for stored Magazine exists in MMKV. If not write it.
    #   
    */
   
    const stored = getStoredMagazineByMagazine(magazine);
    if (!stored) {
        
        if (magazine.numberOfPages) {
            // generate the pageFiles data for the new stored magazine
            const newPageFiles: pageFiles[] = [];
            for (let i = 1; i <= magazine.numberOfPages; i++) {
                newPageFiles.push(
                    {
                        page: i,
                        downloaded: false,
                    }
                )
            }
            // update the new stored magazine
            updateStoredMagazine({
                magazine: magazine,
                pageFiles: newPageFiles,
            });
        } else {
            console.error("pageDownloader - Error - numberOfPages missing in magazine");
        }

    } else {
        console.info("pageDownloader - stored Magazine exists");
    }
    await delay(250);
}
export default async function pageDownloader(magazine: Magazine, currentPage: number) {
    /*
    #
    #   DEV KRAM
    #
    */
    //deleteAllStoredMagazines();
    //console.log("pageDownloader - all_stored ", JSON.stringify(getAllStoredEpapers(), null, 2));
    /*
    #
    #   download the pages that are not downloaded yet
    #   
    */
    const stored = getStoredMagazineByMagazine(magazine);

    if (!stored) {
        console.error("pageDownloader - Error - no stored magazine where one should be");
    } else {
        try {
            for (const storedPageFile of stored.pageFiles || []) {                
                // download the page if needed
                if (storedPageFile.downloaded === false || alwaysRedownload) {
                    await delay(delay_time);
                    const result = await fetchSinglePage(magazine.date, magazine.edition, storedPageFile.page.toString());
                    //console.log(`pageDownloader - Downloaded page ${storedPageFile.page}:`, result);
                    // update the pageFile data
                    if(result)
                        updatePageFile(stored.magazine, storedPageFile.page, new Date);
                }
            }
            console.info("pageDownloader - All pages downloaded");
        } catch (error) {
            console.error("pageDownloader - Error during page download:", error);
        }
    }
}